import React from 'react';
import * as Icon from 'react-feather';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerSponsor: IRouter = {
  path: '/sponsor/:tab',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'sponsor.name', //translate here for breadcrumb and sidebar
  menu: {
    icon: <Icon.Award />,
  },
  permissionCode: PermissionCode.SPONSORS_SEARCH,
  generatePath: () => 'sponsor/checkPermission', //default url
  activePath: 'sponsor',
};
